import { combineReducers } from 'redux'
import detail from './detail.reducer'
import list from './list.reducer'

export default combineReducers({
  detail,
  list
})
